import { render } from "./LayoutMain.vue?vue&type=template&id=686f30b3&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=js"
export * from "./LayoutMain.vue?vue&type=script&lang=js"

import "./LayoutMain.vue?vue&type=style&index=0&id=686f30b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686f30b3"],['__file',"src/components/LayoutMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "686f30b3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('686f30b3', __exports__)) {
    api.reload('686f30b3', __exports__)
  }
  
  module.hot.accept("./LayoutMain.vue?vue&type=template&id=686f30b3&scoped=true", () => {
    api.rerender('686f30b3', render)
  })

}


export default __exports__